import { useQuery } from '@apollo/client';

import FEATURE_FLAG_QUERY from './graphql/FeatureFlagQuery.graphql';
import {
  FeatureFlagQuery,
  FeatureFlagQueryVariables,
} from './graphql/types/FeatureFlagQuery';

const useFeatureFlagQuery = ({
  flagKey,
  skip,
}: FeatureFlagQueryVariables & { skip?: boolean }) => {
  const { data, ...featureFlagQuery } = useQuery<
    FeatureFlagQuery,
    FeatureFlagQueryVariables
  >(FEATURE_FLAG_QUERY, {
    variables: { flagKey },
    skip,
  });

  return {
    ...featureFlagQuery,
    isActive: !!data?.featureFlag?.isActive,
  };
};

export default useFeatureFlagQuery;
